module.exports = __webpack_public_path__ + "static/media/gif-5.a9a05980.gif";